import {
  Delete,
  Edit,
  OpenInNew,
} from "@mui/icons-material";
import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
} from "@mui/material";

export default function RowActionsMenu({
  anchorEl,
  onClose,
  isUserTable,
  row,
  onEdit,
  onView,
  onDeleteRequest,
}) {
  const open = Boolean(anchorEl);
  const hasDelete = Boolean(onDeleteRequest);

  const handleEdit = () => {
    if (row && onEdit) {
      onEdit(row);
    }
    onClose?.();
  };

  const handleView = () => {
    if (row && onView) {
      onView(row);
    }
    onClose?.();
  };

  const handleDelete = () => {
    if (row && hasDelete) {
      onDeleteRequest?.(row);
    }
    onClose?.();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      disablePortal={false}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ zIndex: 99999 }}
      PaperProps={{
        sx: {
          boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          minWidth: "160px",
          zIndex: 99999,
        },
      }}
    >
      <MenuList sx={{ py: 1 }}>
        <MenuItem onClick={handleEdit} sx={{ px: 3, py: 1.5 }}>
          <ListItemIcon sx={{ minWidth: "32px" }}>
            <Edit fontSize="small" sx={{ color: "#6b7280" }} />
          </ListItemIcon>
          <ListItemText
            primary="Edit"
            primaryTypographyProps={{ fontSize: "0.875rem", fontWeight: 500 }}
          />
        </MenuItem>

        {!isUserTable && (
          <>
            <MenuItem onClick={handleView} sx={{ px: 3, py: 1.5 }}>
              <ListItemIcon sx={{ minWidth: "32px" }}>
                <OpenInNew fontSize="small" sx={{ color: "#6b7280" }} />
              </ListItemIcon>
              <ListItemText
                primary="Go to Account"
                primaryTypographyProps={{ fontSize: "0.875rem", fontWeight: 500 }}
              />
            </MenuItem>
          </>
        )}

        <Divider sx={{ my: 1 }} />

        <MenuItem
          onClick={handleDelete}
          disabled={!hasDelete}
          sx={{ px: 3, py: 1.5 }}
        >
          <ListItemIcon sx={{ minWidth: "32px" }}>
            <Delete fontSize="small" sx={{ color: "#ef4444" }} />
          </ListItemIcon>
          <ListItemText
            primary="Delete"
            primaryTypographyProps={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#ef4444",
            }}
          />
        </MenuItem>
      </MenuList>
    </Popover>
  );
}